import { useAppSelector } from "../../hooks"
import { Login } from "./Login"
import { Token } from "./Token"
import { selectAuth } from "./authSlice"

export function Auth() {
  const isAuthenticated = useAppSelector(selectAuth)

  return isAuthenticated ? <Token /> : <Login />
}
